import { useDispatch } from 'react-redux';
import {
  useDocumentsAPI,
  UseFaqsNotesDocumentsAPIReturn,
} from 'src/SharedCustomHooks/UseFaqsNotesDocumentsAPI/useDocumentsAPI';
import { fetchPropertyCounts } from 'src/store/actions/properties';
import { DocumentFormData } from 'src/utils/S3UploadDocumentsUtility';

interface UsePropertyDocumentsAPIOptions {
  propertyId: string;
  userId: string;
  roleName: string;
}

export const usePropertyDocumentsAPI = ({
  propertyId,
  userId,
  roleName,
}: UsePropertyDocumentsAPIOptions): UseFaqsNotesDocumentsAPIReturn => {
  const dispatch = useDispatch();
  const base: UseFaqsNotesDocumentsAPIReturn = useDocumentsAPI();

  const refreshPropertyCounts = (): void => {
    dispatch(fetchPropertyCounts(propertyId, userId, roleName));
  };

  const saveDocument = async (
    document: DocumentFormData,
    entityId: string,
    savedByUserId: string
  ): Promise<void> => {
    await base.saveDocument(document, entityId, savedByUserId);
    refreshPropertyCounts();
  };

  const deleteDocument = async (documentId: string): Promise<boolean> => {
    const didDelete: boolean = await base.deleteDocument(documentId);
    if (didDelete) refreshPropertyCounts();
    return didDelete;
  };

  return {
    ...base,
    saveDocument,
    deleteDocument,
  };
};
